export default __webpack_public_path__ + "static/media/page5Image1.32c297ac.png";